import React, { useMemo } from "react";
import { View, StyleSheet } from "react-native";
import NtTouchableEffect from "./NtTouchableEffect";
import NtMaterialIcon from "./NtMaterialIcon";
import NtText from "./NtText";
import { useTheme } from "../context/ThemeContext";

function NtEmailItem({ containerStyle, email, onDelete }) {
  const { theme } = useTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);

  return (
    <View style={[styles.container, containerStyle]}>
      <NtText style={styles.text}>{email}</NtText>
      {onDelete ? (
        <NtTouchableEffect style={{ marginLeft: 6 }} onPress={onDelete}>
          <NtMaterialIcon name="close" size={14} color={theme.textDim} />
        </NtTouchableEffect>
      ) : null}
    </View>
  );
}

const makeStyles = (t) =>
  StyleSheet.create({
    container: {
      backgroundColor: t.surface3,
      borderWidth: 1,
      borderColor: t.borderSoft,
      paddingHorizontal: 8,
      paddingVertical: 3,
      borderRadius: t.radius,
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "row",
    },
    text: { fontSize: 11, fontWeight: "500", color: t.textDim },
  });

export default NtEmailItem;
